define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/aspect",
	"dojo/store/Memory",
	"csi/action/ActionView",
	"csi/def",
	"csi/def/Field",
	"csi/locale",
	"csi/reflection",
	"csi/table/New",
	"csi/xml"
], function(declare, lang, aspect, Memory, ActionView, def, Field, locale, reflection, New, xml) {

	var COMBINEPATH = xml.path("Actual", "Definition");
	var DEFINITION_FORM_ID = "SpecificationItemDefinition";
	var DESCRIPTION = "Description";
	var DESCRIPTION_PATH_SSI = xml.path("Actual");
	var SECTION_ITEM_FORM_ID = "SpecificationSectionItem";
	var SECTION_ITEM_FORM = "Actual";

	return declare(New, {
		/**
		 * @override
		 * always return true for this form because the action controller populates the fields
		 */
		 isValidActionView: function(){
			return true;
		},

		/**
		 * Combine the SDI form
		 * Handle the Description attribute from two forms(SDI&SSI)
		 * @param {csi.view.Widget} view
		 */
		onCreatePopup: function(view) {
			view.combineForm(true, SECTION_ITEM_FORM);

			// add the description attribute of the SSI form by default if not exist
			if (!view.getField(view.getCombinedFieldName(SECTION_ITEM_FORM_ID, DESCRIPTION))) {
				var f = lang.mixin(new Field(), {
					m_id: DESCRIPTION,
					m_path: DESCRIPTION_PATH_SSI
				});

				view.insertField(f, 0);
			}

			view.combineFormAlongPath(true, COMBINEPATH);

			// check if description attribute of the SDI form exist, if it does, remove it
			view.defView.removeField(view.getCombinedFieldName(DEFINITION_FORM_ID, DESCRIPTION));

			var dataSheetItem = this.getCache().getNode(this.getParent().__Parent__);
			view.addFixedValue(view.getCombinedFieldName(DEFINITION_FORM_ID, reflection.ATTR_SUBTYPE), dataSheetItem.Subtype);

			// Add Section field, if action came from toolbar
			var w = this.widget;
			if (w.isNewActionsButton(this.refNode)) {
				var f = lang.mixin(new Field(), {
					bForceEditable: true,
					m_bRequired: true,
					m_id: "Section",
					m_label: locale.resource("SpecificationSection"),
					m_typeControl: def.FIELD_FILTERING_SELECT
				});
				view.insertField(f, "SpecificationItemDefinition/Subtype");
				aspect.after(view, "getFieldStore", function(retVal, args) {
					var field = args[0];
					if (field.m_id == "Section") {
						return w.getEditableSectionsStore();
					}
					return retVal;
				});
			}

			this.inherited(arguments);
		},

		/**
		 * Add the section attribute
		 * @param {CallMethod} call
		 * @return {Boolean}
		 */
		_writeRequestParameters: function(call) {
			this.inherited(arguments);

			var descriptionValue = this.popupView.getFieldValue(DESCRIPTION);
			if (descriptionValue) {
				call.addParameter(DESCRIPTION, xml.ATTR_STRING, descriptionValue);
			}

			if (this._groupResults) {
				this._groupResults.every(function(groupResult, index) {
					var groupUrl = groupResult.groupValue;
					var groupId = groupResult.level.groupSpec.heading.m_id;

					if (groupId == "Section") {
						call.addParameter("Section", xml.ATTR_REF, groupUrl);
					}

					return false;
				});
			} else if (this.widget.isNewActionsButton(this.refNode)) {
				var sectionURL = this.popupView.getFieldValue(locale.resource("SpecificationSection"));
				if (sectionURL) {
					call.addParameter("Section", xml.ATTR_REF, sectionURL);
				}

			}
		}
	});
});